import React from 'react';
import './PageLoadingSpinner.css';

/**
 * Same Bootstrap spinner as PracticeDashboard initial load.
 * Centered in the main content area via shared LoadingSpinner.css.
 */
const PageLoadingSpinner = ({ className = '' }) => (
  <div className={['page-loading-spinner-container', className].filter(Boolean).join(' ')}>
    <div className="spinner-border text-primary" role="status">
      <span className="visually-hidden">Loading...</span>
    </div>
  </div>
);

export default PageLoadingSpinner;
